import { render } from "./BackCrumb.vue?vue&type=template&id=2009e312&scoped=true"
import script from "./BackCrumb.vue?vue&type=script&lang=js"
export * from "./BackCrumb.vue?vue&type=script&lang=js"

import "./BackCrumb.vue?vue&type=style&index=0&id=2009e312&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2009e312"

export default script